export const IsNull = (value) => {
    if (value === undefined || value === null) {
        return true;
    }

    if (value === "undefined" || value === "null") {
        return true;
    }
    if (value === "" || value === " ") {
        return true;
    }
    return false;


}


export const localStoreObjects = {
    userId: "userId",
    bgmiProfile: "bgmiProfile",
    profilePic: "profilePic",
    step: "step"
}

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export const host = isLocalhost ? "http://localhost:5000/api/" : "https://waliachandan.com/api/";

export function convertDate(dateStr) {
    // Convert string to Date object
    const date = new Date(dateStr);

    // Format as "Month Day, Year"
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}



export const timeOptions = [
  { value: 5, label: "5 minutes" },
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 60, label: "1 hour" },
  { value: 120, label: "2 hours" },
  { value: 240, label: "4 hours" },
  { value: 480, label: "8 hours" },
  { value: 720, label: "12 hours" },
  { value: 1440, label: "1 day" },
  { value: 2880, label: "2 days" },
];